
<div class="creative-people-area bg_image--50 ptb--200 ptb-md--80 ptb-sm--80">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="creative-people-inner text-center">
                    <h2 class="heading">Neuro Akashico<sup>®</sup><span class="theme-color"> el Gran Observador</span></h2>
                    <h2 style="margin-top: 20px;"><span class="theme-color" style="font-size: xx-large; background-color: antiquewhite; padding: 5px 15px;"> MASTERCLASS</span></h2>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Info del curso -->
<div class="bk-number-speaks section-ptb-xl bg_image--3">
    <div class="container">
        <div class="row">

            <div class="col-lg-6 col-xl-6 col-md-12 col-sm-12 col-12">
                <div class="number-speaks">
                    <div class="content wow move-up">
                        <h3 style="font-size: 20px; color: rgb(255, 255, 255);"><span style="background-color: rgb(69, 29, 163); padding: 5px 10px;">MASTERCLASS</span></h3>
                        <h2>NeuroAkashico® <br> <span class="secondary-color" style="font-size: 30px;">Combustible y alimento para nuestras células</span></h2>
                        <div style="margin-top:15px;"> <img src="assets/img/neuroakashico.png" alt="Brook Preloader"></div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xl-6 col-md-12 col-sm-12 col-12 mt_md--40 mt_sm--40">
                <div class="speakers-number-wrap">

                    <div class="tab">
                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="pills-home-tab" data-toggle="pill"
                                    href="#pills-home" role="tab" aria-controls="pills-home"
                                    aria-selected="true">Costo</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="pills-profile-tab" data-toggle="pill"
                                    href="#pills-profile" role="tab" aria-controls="pills-profile"
                                    aria-selected="false" style="background: #491d6b; color: white; margin-left: 10px;">
                                    Objetivos</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="pills-detalles-tab" data-toggle="pill"
                                    href="#pills-detalles" role="tab" aria-controls="pills-detalles"
                                    aria-selected="false" style="background: #f39302; color: white; margin-left: 10px;">
                                    Beneficios</a>
                            </li>
                            
                        </ul>
                        <div class="tab-content" id="pills-tabContent" >
                            <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
                                aria-labelledby="pills-home-tab">
                                <app-ngoclase></app-ngoclase>
                            </div>
                            <div class="tab-pane fade" id="pills-profile" role="tabpanel"
                                aria-labelledby="pills-profile-tab" >
                                <div style="margin-top: 20px"> 
                                    <h4>Objetivos</h4>
                                        <ul>
                                        <li>Lograr que cada asistente, integre el ABC del Observador.</li>
                                        <li style="padding-top: 10px;">Entendimiento de lo que es transformarse en el 
                                            Gran Observador en estos momentos que se está viviendo actualmente.</li>
                                        </ul>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="pills-detalles" role="tabpanel"
                                aria-labelledby="pills-detalles-tab" >
                                <h4>Beneficios:</h4>
                                    <ul>
                                    <li >Logre equilibrio, mejore sus vínculos y calidad de vida, goce  de un estado 
                                        optimo de salud y armonía, de mayor bienestar, plenitud, sobre todo amor. </li>
                                    <li style="padding-top: 10px;">Lugar: modalidad en línea: vía zoom y/o plataforma E-Learning</li>
                                    <li style="padding-top: 10px;">Acceso a material grabado. </li>
                                    <li style="padding-top: 10px;">1 Máster class de 60 minutos </li>
                                    <li style="padding-top: 10px;">1 Clase mensual por 1 año, pregunta por este paquete completo.</li>
                                    </ul>
                            </div>
                           
                        </div>
                    </div>

                   

                  
                </div>
            </div>
        </div>
    </div>
</div>

<app-beneficios></app-beneficios>


